<div class="wm-slot-reservation-editor">
  <div class="wm-slot-reservation-calendar-header">
    <h3>Reserve {{slot.name}}</h3>
    <div class="wm-slot-reservation-navigation">
      <button pButton type="button" class="p-button-text" aria-label="Previous week" (click)="previousWeek()">
        <fa-icon icon="caret-left"></fa-icon>
      </button>
      <button pButton type="button" class="p-button-text" (click)="currentWeek()">This week</button>
      <button pButton type="button" class="p-button-text" aria-label="Next week" (click)="nextWeek()">
        <fa-icon icon="caret-right"></fa-icon>
      </button>
    </div>
    <span class="wm-slot-reservation-calendar-title">{{calendarTitle}}</span>
  </div>

  <div class="wm-slot-reservation-calendar">
    @if (busy && calendarEvents.length === 0) {
      <p-progressSpinner ariaLabel="Loading reservations"></p-progressSpinner>
    }
    <full-calendar #reservationCalendar [options]="calendarOptions" [events]="calendarEvents"></full-calendar>
  </div>

  <div class="wm-slot-reservation-footer">
    <div class="wm-slot-reservation-selection">
      <label>
        <span>Start</span>
        <p-date-picker
            appendTo="body"
            [baseZIndex]="10000"
            [showTime]="true"
            [stepMinute]="5"
            hourFormat="24"
            dateFormat="mm/dd/yy"
            placeholder="Start date"
            [minDate]="currentDate"
            [ngModel]="startValue"
            (ngModelChange)="updateStart($event)"></p-date-picker>
      </label>
      <label>
        <span>End</span>
        <p-date-picker
            appendTo="body"
            [baseZIndex]="10000"
            [showTime]="true"
            [stepMinute]="5"
            hourFormat="24"
            dateFormat="mm/dd/yy"
            placeholder="End date"
            [minDate]="startValue || currentDate"
            [ngModel]="endValue"
            (ngModelChange)="updateEnd($event)"></p-date-picker>
      </label>
      @if (validationMessage) {
        <span class="validation">{{validationMessage}}</span>
      }
    </div>
    <div class="wm-slot-reservation-submit">
      <span aria-hidden="true">&nbsp;</span>
      <button pButton type="button" [disabled]="!canCreateReservation" (click)="createReservation()">
        @if (busy) {
          <fa-icon icon="cog" animation="spin"></fa-icon>
        } @else {
          <fa-icon icon="calendar-plus"></fa-icon>
        }
        Reserve Slot
      </button>
    </div>
  </div>
</div>
